import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { MACRO_FIELDS } from "./macro-fields"

export const createMacro = api(async function createMacro({ input }) {
    if (!input) return null
    return mutate(
        gql`
            mutation CreateMacro($input: MacroInput!) {
                createMacro(input: $input) {
                    ${MACRO_FIELDS}
                }
            }
        `,
        { input },
        { returns: "createMacro" }
    )
})
